import template from './rw-card.html';

export default {
  transclude: true,
  template,
  bindings: {
    name: '=',
    thumbnail: '=',
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-card/rw-card-component.js